import firebase from 'firebase'
require('firebase/auth')

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: 'biz.rentalios.com',
  databaseURL: 'https://rentalios-jonajo.firebaseio.com',
  projectId: 'rentalios-jonajo',
  storageBucket: 'rentalios-jonajo.appspot.com',
  messagingSenderId: '357345955395',
  appId: '1:357345955395:web:ace7e7df350dddc2720ef6',
  measurementId: 'G-HSFKBF7NJY'
}

const app = firebase.initializeApp(firebaseConfig)
const analytics = app.analytics()
const auth = firebase.auth(app)

export { auth, analytics, firebase }
